//------ Imports
import { useState } from "react";
import style from "./portfolio.module.scss";

//------ Components
import CardProject from "./CardProject/CardProject";
import Modal from "../Modal/Modal";

//------ Functions and Arrays
import { category, technology } from "./functions/filters";
import filterProject from "./functions/filterProject";
import apps from "./functions/apps";

function Portfolio({ translation }) {
  const [modal, setModal] = useState({
    data: {},
    show: false,
  });

  const [term, setTerm] = useState({
    technology: [],
    category: "",
  });

  const handleOnChange = (e) => {
      setTerm((prev) => ({ 
        ...prev,
        [e.target.name]: prev[e.target.name] === e.target.value ? "" : e.target.value
      }));
  };

  return (
    <div className={style.container} id="portfolio">
      <h3>{translation("navbar.portfolio")}</h3>
      <div className={style.container__filter}>
        <p>{translation("filter.filterbycategory")}</p>
        <div className={style.container__filter__group}>
          {category(translation).map((f, i) => {
            return (
              <button
                name="category"
                value={f}
                onClick={(e) => handleOnChange(e)}
                key={i}
                className={`${
                  f === term.category && style.container__filter__group_active
                }`}
              >
                {f}
              </button>
            );
          })}
        </div>
        <p>{translation("filter.filterbytechnology")}</p>
        <div className={style.container__filter__group}>
          {technology(translation).map((f, i) => {
            return (
              <button
                name="technology"
                value={f}
                onClick={(e) => handleOnChange(e)}
                key={i}
                className={`${
                  term.technology.includes(f) && style.container__filter__group_active
                }`}
              >
                {f}
              </button>
            );
          })}
        </div>
      </div>
      <div className={style.container__projects}>
        {
        apps(translation)
        ?.filter(filterProject(term))?.length > 0 ? 
        apps(translation)
          ?.filter(filterProject(term))
          ?.map((e, i) => {
            return (
              <CardProject
                key={i}
                title={e.title}
                technology={e.technology}
                img={e.img}
                linkDeploy={e.linkDeploy}
                linkGithub={e.linkGithub}
                text={e.text}
                templateimg={e.templateimg}
                deployed={e.deployed}
                images={e.images}
                type={e.type}
                setModal={setModal}
              />
            );
          })
        :
        <p className={style.container__projects_error}>No se encontró ningún proyecto que coincidiera con los filtros seleccionados.</p>
        }
      </div>
      {modal.show && <Modal setModal={setModal} modal={modal} />}
    </div>
  );
}

export default Portfolio;
